import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["ref"];
import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useRef } from 'react';
import { usePopover } from '@frameio/vapor';
import { IconChevronDown } from '@frameio/vapor-icons';
import { GUIDES_URL, API_REFERENCE_URL, CHANGELOGS_URL } from '../../../utils/constants';
import { Link } from '../../../utils/helpers';
import { DropdownButton, DropdownMenu, DropdownMenuButton, StyledPopoverContent } from '../../Dropdown';

var Dropdown = function Dropdown() {
  var initialFocusRef = useRef();

  var _usePopover = usePopover({
    initialFocusRef: initialFocusRef,
    defaultShowing: false
  }),
      bindTarget = _usePopover.bindTarget,
      bindContent = _usePopover.bindContent;

  var ref = bindTarget.ref,
      bind = _objectWithoutProperties(bindTarget, _excluded);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownButton, _extends({}, bind, {
    focusRef: ref,
    iconAfter: /*#__PURE__*/React.createElement(IconChevronDown, {
      size: 16
    })
  }), "Docs"), /*#__PURE__*/React.createElement(StyledPopoverContent, _extends({}, bindContent, {
    zIndex: 50
  }), /*#__PURE__*/React.createElement(DropdownMenu, {
    ref: initialFocusRef
  }, /*#__PURE__*/React.createElement(Link, {
    to: GUIDES_URL
  }, /*#__PURE__*/React.createElement(DropdownMenuButton, null, "Guides")), /*#__PURE__*/React.createElement(Link, {
    to: API_REFERENCE_URL
  }, /*#__PURE__*/React.createElement(DropdownMenuButton, null, "API Reference")), /*#__PURE__*/React.createElement(Link, {
    to: CHANGELOGS_URL
  }, /*#__PURE__*/React.createElement(DropdownMenuButton, null, "Changelogs")))));
};

export default Dropdown;